import script from "./RepairMaintenanceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./RepairMaintenanceSection.vue?vue&type=script&setup=true&lang=js"

import "./RepairMaintenanceSection.vue?vue&type=style&index=0&id=130656c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130656c0"]])

export default __exports__